import { ReactNode } from "react";
import { Spinner } from "react-bootstrap";

interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading: boolean;
  minWidth?: string;
}

export const LoadingButton: React.FC<IButtonProps> = ({
  loading,
  children,
  minWidth = "100px",
  className,
  onClick,
  ...buttonProps
}) => {
  return (
    <button
      className={`btn btn-primary ${className}`}
      onClick={(e) => {
        if (!loading && onClick) {
          onClick(e);
        }
      }}
      {...buttonProps}
    >
      {loading ? (
        <div style={{ minWidth: minWidth }}>
          <Spinner animation="border" size="sm" />
        </div>
      ) : (
        children
      )}
    </button>
  );
};
